import { css } from '@emotion/react';
export const gridStyles = css`

`;
export const styles = ()=>({
        root: {
            height: '100%',
            width: '100%'
        }
    });
